<div class="row">
  <div class="col-md-6 fw-regular mb-1">{{ type | titlecase }} equipment
  </div>
</div>

@for (item of list.controls; track item; let i = $index) {
  <div class="card position-relative my-3">
    <div class="position-absolute end-0">
      @if (list.length > 1) {
        <button
          class="btn btn-outline-danger rounded-circle p-1 px-2 text-danger h1 mb-0 me-2 mt-2 border-0 shadow-none"
          (click)="deleteEquipmentItem(i)"
        >
          <i class="fa-light fa-trash-can"></i>
        </button>
      }
    </div>
    <div class="card-body p-4">
      <div class="row g-4">
        <app-form-field label="Type and size" class="col-12 col-md-3" [includeMargin]="false">
          <app-equipment-category-amsterdam
            [equipmentLength]="item.controls.equipmentLength.getRawValue()"
            [equipmentType]="item.controls.equipmentType.getRawValue()"
            (equipmentLengthChange)="item.controls.equipmentLength.setValue($event)"
            (equipmentTypeChange)="item.controls.equipmentType.setValue($event)"></app-equipment-category-amsterdam>
        </app-form-field>
        <app-form-field label="State" class="col-12 col-md-3" [includeMargin]="false">
          <app-radio [formControl]="item.controls.empty" [inline]="true" [formatter]="formatEmpty"
                     [options]="[true, false]" required></app-radio>
        </app-form-field>
        <app-form-field label="Number" class="col-12 col-md-3" [includeMargin]="false">
          <input class="form-control" [formControl]="item.controls.count" type="number" size="9" maxlength="9"
                 required [placeholder]="'e.g. 100'">
        </app-form-field>
      </div>
    </div>
  </div>
}
<button type="button" class="btn btn-outline-primary" (click)="addEquipment()">
  <i class="fa-solid fa-plus me-2"></i>
  <span>Add {{ type }} equipment</span>
</button>
